import { ReactNode } from 'react';
import { Body, Container, Head, Html, Preview } from '@react-email/components';
import { useContentComposer } from '../content-composer-provider';

export const DOCTYPE =
  '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">';

type Props = {
  preview?: string;
  header?: ReactNode;
  children?: ReactNode;
  renderMode?: string;
};

export const HtmlTemplate = ({ preview, header, renderMode, children }: Props) => {
  const { composerMode } = useContentComposer();

  if (composerMode === 'feedback' && renderMode !== 'preview') {
    return (
      <div style={headlessBodyStyle}>
        {!!children && <Container style={headlessContainerStyle}>{children}</Container>}
      </div>
    );
  }

  return (
    <Html style={{ overflowX: 'hidden' }}>
      <Head />
      {!!preview && <Preview>{preview}</Preview>}
      <Body style={bodyStyle}>
        {!!header && header}
        {!!children && <Container style={containerStyle}>{children}</Container>}
      </Body>
    </Html>
  );
};

const bodyStyle = {
  fontFamily: '"DM Sans", sans-serif',
  backgroundColor: '#ffffff',
  margin: '0',
  padding: '0',
};

const headlessBodyStyle = {
  maxWidth: '640px',
  borderRadius: '8px',
  backgroundColor: '#fff',
  boxShadow: '0 4px 10px 0 rgb(42, 38, 56, 14%)',
  padding: '4px',
  margin: '24px auto',
  fontFamily: '"DM Sans", sans-serif',
};

const headlessContainerStyle = {
  margin: '0 auto',
  maxWidth: '100%',
  position: 'relative' as const,
};

const containerStyle = {
  margin: '0 auto',
  maxWidth: '640px',
  position: 'relative' as const,
};
